import LoadingPhotoCard from "./UI/LoadingPhotoCard";

const LoadingDisplay = props => {
  return (
    <>
      <LoadingPhotoCard />
      <LoadingPhotoCard />
      <LoadingPhotoCard />
    </>
  );
}

export default LoadingDisplay;